import { graphql } from '@apollo/client/react/hoc'

import { graphene } from 'graphql/tags'

const cancelStyleColorsFromOrder = graphene`#graphql
  mutation CancelStyleColorsFromOrder(
    $input: BatchCancelStylesFromOrderInput!
  ) {
    batchCancelStylesFromOrder(input: $input) {
      cancelledStyleColors {
        id
      }
    }
  }
`

export const withCancelStyleColorsFromOrder = graphql(
  cancelStyleColorsFromOrder,
  {
    props: ({ mutate }) => ({
      handleCancelStyleColorsFromOrder: (orderId, styleColorIds) =>
        mutate({
          variables: {
            input: {
              orderId,
              styleColorIds,
            },
          },
        }),
    }),
  },
)
